import Vue from "vue"

Vue.mixin({
	methods: {
		hasAuth(perm) {
			let authority = this.$store.state.menus.permList
			return authority.indexOf(perm) > -1
		}
	}
})

String.prototype.format = function() {
  if(arguments.length == 0)
    return this;

  let s = this
  for(let i=0; i<arguments.length; i++) {
    s = s.replace(new RegExp("\\{" + i + "\\}", "g"), arguments[i]);
  }

  return s;
}



// WEBPACK FOOTER //
// ./src/globalFun.js